import React from 'react';
import { Select } from 'antd';
import FormItem from './FormItem';
import NotEditableItem from './NotEditableItem';

export default function FormSelect({ editable, name, value, error, onChange, layout, label, required, showSearch, formItemClass, ...props }) {
  if (!editable) {
    return (
      <NotEditableItem title={props.placeholder} value={value} />
    );
  }

  if (showSearch) {
    props.filterOption = (input, option) => (
      option.props.children.toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    );
  }

  return (
    <FormItem
      label={label}
      required={required}
      error={error}
      layout={layout}
      className={formItemClass}
    >
      <Select
        name={name}
        value={value}
        onChange={onChange}
        {...props}
      />
    </FormItem>
  );
}

FormSelect.prepareOptions = prepareOptions;

function prepareOptions(data) {
  if (!Array.isArray(data)) {
    throw new Error('Wrong data for Select options');
  }

  return data.map(({ name, ...props }) => (
    <Select.Option key={name} {...props}>{name}</Select.Option>
  ));
}



// WEBPACK FOOTER //
// ./src/components/BaseForm/components/Select.js